import { Outlet } from 'react-router-dom';
import { MedplumDirectoryUsersProvider } from '../../hooks/useMedplumDirectoryUsers';

/**
 * Shares Medplum directory state across Settings sections and `/settings/users/:id`.
 */
export function MedplumDirectoryUsersLayout(): JSX.Element {
  return (
    <MedplumDirectoryUsersProvider>
      <Outlet />
    </MedplumDirectoryUsersProvider>
  );
}
